import React from "react";
import { useTranslation } from 'react-i18next';
import Pindots from "../../assets/threeDotsPart.png";
import pinnedPnc from "../../assets/pinnedPnc.svg";
import deletePnc from "../../assets/deletePnc.svg";
import pinPnc from "../../assets/pinPnc.svg";

const PinnedChats = ({
  pinnedChats,
  selectedHistoryId,
  handleHistoryItemClick,
  handleLongPressStart,
  handleLongPressEnd,
  toggleDropdown,
  activeDropdownId,
  dropdownRef,
  handleDeleteButtonClick,
  handleUnpinButtonClick,
  isMobile
}) => {
  const { t } = useTranslation();
  
  return (
    <div className="space-y-2">
      <h3 className="pinned today">
        <span className="flex items-center gap-[8px]">
            {t('pinnedChat')}
          <img src={pinnedPnc} alt="Pinned" />
        </span>
      </h3>
      <div className="gap-[4px] grid">
        {pinnedChats.map((item, index) => (
          <div
            key={`pinned-${item.chat_id || item.title_id}-${index}`}
            className={`p-2 ${
              selectedHistoryId === (item.chat_id || item.title_id)
                ? "bg-[#FFE0E0]"
                : "hover:bg-[#FFE0E0]"
            } rounded cursor-pointer titleBar`}
            onClick={() => handleHistoryItemClick(item)}
            onTouchStart={isMobile ? (e) => handleLongPressStart(item.chat_id || item.title_id, e) : undefined}
            onTouchEnd={isMobile ? handleLongPressEnd : undefined}
            onTouchMove={isMobile ? handleLongPressEnd : undefined}
            onTouchCancel={isMobile ? handleLongPressEnd : undefined}
          >
            <p className="text-black titleHead">
              {item.title || `Conversation ${index + 1}`}
            </p>
            <div className="dropdown-container relative">
              {/* Only show three dots on desktop */}
              {window.innerWidth >= 640 && (
                <img
                  src={Pindots}
                  alt="Menu"
                  className="cursor-pointer threeDotsPnc"
                  onClick={(e) => toggleDropdown(item.chat_id || item.title_id, e)}
                />
              )}
              {activeDropdownId === (item.chat_id || item.title_id) && (
                <div
                  ref={dropdownRef}
                  className="absolute right-0 top-full mt-1 bg-white shadow-lg rounded-md z-10 w-[180px]"
                >
                  <ul className="popSectionPnc">
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gapDeletePnc"
                      onClick={(e) => handleDeleteButtonClick(item, e)}
                    >
                      <div>
                        <img className="deleteIcoPnc" src={deletePnc} alt="Delete" />
                      </div>
                      <span className="text-sm">{t('deleteChat')}</span>
                    </li>
                    <li
                      className="px-4 py-2 hover:bg-gray-100 cursor-pointer flex items-center gapDeletePnc"
                      onClick={(e) => handleUnpinButtonClick(item, e)}
                    >
                      <div>
                        <img className="deleteIcoPnc" src={pinPnc} alt={t('unpin')} />
                      </div>
                      <span className="text-sm">{t('unpinChat')}</span>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PinnedChats;